import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";

export const useAvailabilityRecalculationPastDaysLimit = (): number => {
  const {
    data: { availability }
  } = useMyAccountInfo();

  const { availability_recalculation_past_days_limit: availabilityRecalculationPastDaysLimit } =
    availability || {};

  return availabilityRecalculationPastDaysLimit ?? 0;
};
